import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ControlService {

  baseUrl = `${environment.apis.base}/user`;

  constructor(private readonly http: HttpClient) { }

  /**
   * Verifica si el usuario autenticado es administrador.
   * @returns Observable con { is_admin: boolean }
   */
  isAdmin(): Observable<{ is_admin: boolean }> {
    return this.http.get<{ is_admin: boolean }>(`${this.baseUrl}/is-admin`);
  }
}
